import React from 'react';
import {
  Paper,
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Card,
  CardContent,
  Box,
  Chip,
} from '@mui/material';
import {
  WaterDrop,
  AttachMoney,
  CalendarToday,
  LocationOn,
} from '@mui/icons-material';

const FarmerProfile = ({ farmerId }) => {
  // This would typically come from your backend
  const farmerData = {
    id: 1,
    name: 'John Doe',
    phone: '1234567890',
    village: 'Green Village',
    totalDue: 5000,
    totalArea: '5 acres',
    activeIrrigation: true,
  };

  const irrigationHistory = [
    {
      id: 1,
      date: '2024-02-01',
      crop: 'Wheat',
      duration: '2 hours',
      amount: 1000,
      status: 'Completed',
    },
    {
      id: 2,
      date: '2024-01-28',
      crop: 'Cotton',
      duration: '3 hours',
      amount: 1500,
      status: 'Completed',
    },
  ];

  const billingHistory = [
    {
      id: 1,
      date: '2024-02-01',
      amount: 1000,
      type: 'Charge',
      description: 'Irrigation service',
    },
    {
      id: 2,
      date: '2024-01-25',
      amount: 500,
      type: 'Payment',
      description: 'Cash payment',
    },
  ];

  return (
    <div>
      <Grid container spacing={3}>
        {/* Farmer Overview */}
        <Grid item xs={12}>
          <Paper sx={{ p: 3 }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Typography variant="h5" gutterBottom>
                  {farmerData.name}
                </Typography>
                <Typography color="textSecondary" gutterBottom>
                  <LocationOn sx={{ mr: 1, verticalAlign: 'middle' }} />
                  {farmerData.village}
                </Typography>
                <Typography>
                  Phone: {farmerData.phone}
                </Typography>
                <Typography>
                  Total Area: {farmerData.totalArea}
                </Typography>
                {farmerData.activeIrrigation && (
                  <Chip
                    color="primary"
                    label="Active Irrigation"
                    icon={<WaterDrop />}
                    sx={{ mt: 1 }}
                  />
                )}
              </Grid>

              <Grid item xs={12} md={6}>
                <Card>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Total Due Amount
                    </Typography>
                    <Typography variant="h4" color="error">
                      ₹{farmerData.totalDue}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        {/* Irrigation History */}
        <Grid item xs={12}>
          <Paper>
            <Box sx={{ p: 2 }}>
              <Typography variant="h6">
                Irrigation History
              </Typography>
            </Box>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>Crop</TableCell>
                    <TableCell>Duration</TableCell>
                    <TableCell>Amount</TableCell>
                    <TableCell>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {irrigationHistory.map((record) => (
                    <TableRow key={record.id}>
                      <TableCell>{record.date}</TableCell>
                      <TableCell>{record.crop}</TableCell>
                      <TableCell>{record.duration}</TableCell>
                      <TableCell>₹{record.amount}</TableCell>
                      <TableCell>
                        <Chip
                          label={record.status}
                          color={record.status === 'Completed' ? 'success' : 'warning'}
                          size="small"
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>

        {/* Billing History */}
        <Grid item xs={12}>
          <Paper>
            <Box sx={{ p: 2 }}>
              <Typography variant="h6">
                Billing History
              </Typography>
            </Box>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>Description</TableCell>
                    <TableCell>Type</TableCell>
                    <TableCell>Amount</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {billingHistory.map((record) => (
                    <TableRow key={record.id}>
                      <TableCell>{record.date}</TableCell>
                      <TableCell>{record.description}</TableCell>
                      <TableCell>
                        <Chip
                          label={record.type}
                          color={record.type === 'Payment' ? 'success' : 'error'}
                          size="small"
                        />
                      </TableCell>
                      <TableCell>₹{record.amount}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

export default FarmerProfile;
